import { CommonModule } from '@angular/common';
import { Component, ElementRef, Input, TemplateRef } from '@angular/core';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { SafePipe } from '../../pipes/safe.pipe';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzButtonModule } from 'ng-zorro-antd/button';

@Component({
  selector: 'app-fieldset',
  templateUrl: './fieldset.component.html',
  styleUrl: './fieldset.component.scss',
  standalone: true,
  imports: [
    CommonModule,
    NzIconModule,
    SafePipe,
    NzToolTipModule,
    NzButtonModule,
  ],
})
export class FieldsetComponent {
  @Input('legend') legend: TemplateRef<ElementRef> | any;
  @Input('nzIcon') nzIcon: string | null | undefined;
  @Input('hide') hideContent = false;
  @Input('collapsible') collapsible = true;
  @Input('actions') actions: TemplateRef<ElementRef>;
  useClassicLegend = false;

  isTemplateLegend(): boolean {
    return this.legend instanceof TemplateRef;
  }
}
